const exhibitionRoute = [
  {
    path: '/exhibition',
    component: () => import('@/views/exhibition'),
    redirect: '/exhibition/index',
    meta: {
      title: '产品展示',
      breadcrumb: true,
      layout: 'DefaultLayout'
    },
    children: [
      {
        path: "index",
        component: () => import('@/views/exhibition/main.vue'),
        hidden: true,
        meta: {
          title: "产品展示",
          breadcrumb: false
        }
      },
      {
        path: 'smart-terminal',
        component: () => import('@/views/exhibition/Exhibition1.vue'),
        meta: { title: '智能终端' }
      },
      {
        path: 'smart-home',
        component: () => import('@/views/exhibition/Exhibition2.vue'),
        meta: { title: '智能家居' }
      },
      {
        path: 'smart-lock',
        component: () => import('@/views/exhibition/Exhibition3.vue'),
        meta: { title: '智能锁' }
      },
      {
        path: 'detail/:id',
        component: () => import('@/views/exhibition/DetailPage.vue'),
        hidden: true,
        meta: {
          title: '产品详情',
          breadcrumb: true
        }
      }
    ]
  }
]
export default exhibitionRoute
